import { Alert, Snackbar } from '@mui/material';
import { createContext, useCallback, useContext, useState } from 'react';

const defaultProps = {
    type: 'info',
    anchorOrigin: { vertical: 'top', horizontal: 'center' },
    autoHideDuration: 5000,
};

const ToastContext = createContext();

export const useToast = () => {
    const showToast = useContext(ToastContext);
    if (!showToast) {
        throw new Error('useToast must be used within a ToastContextProvider');
    }

    const showInfoToast = useCallback(
        (message, options = {}) => showToast(message, { type: 'info', ...options }),
        []
    );
    const showSuccessToast = useCallback(
        (message, options = {}) => showToast(message, { type: 'success', ...options }),
        []
    );
    const showErrorToast = useCallback(
        (message, options = {}) => showToast(message, { type: 'error', ...options }),
        []
    );

    return { showToast, showInfoToast, showSuccessToast, showErrorToast };
};

export const ToastContextProvider = ({ children }) => {
    const [toast, setToast] = useState({});

    const { message, type, ...rest } = toast;

    const closeToast = useCallback(() => {
        setToast({});
    }, []);

    const showToast = useCallback(
        (newMessage = '', options = {}) =>
            setToast({ message: newMessage, ...defaultProps, ...options }),
        []
    );

    return (
        <ToastContext.Provider value={showToast}>
            {children}
            <Snackbar {...rest} open={Boolean(message)} onClose={closeToast}>
                <Alert onClose={closeToast} severity={type}>
                    {message}
                </Alert>
            </Snackbar>
        </ToastContext.Provider>
    );
};
